import styled from 'styled-components';
import { Popover } from 'visits-style';

export default styled(Popover)`
  border: none;
  box-shadow: ${({ theme }) => theme.boxShadow};
`;
